import { FC } from "react";

import { Box, LinearProgress } from "@mui/material";

import { progressBarDelayMs } from "@constants";

const RouteLoadingFallback: FC = () => {
  return (
    <Box sx={{ minHeight: "70vh" }} data-cy="route-loading-bar">
      <LinearProgress
        color="secondary"
        sx={{
          height: 3,
          opacity: 0,
          animation: `routeLoadingBarFadeIn 150ms ease-out ${progressBarDelayMs}ms forwards`,
          "@keyframes routeLoadingBarFadeIn": { to: { opacity: 1 } },
        }}
      />
    </Box>
  );
};

export default RouteLoadingFallback;
